import { Box, Container, Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Skeleton } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  a: {
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
      flexDirection: "row",
      justifyContent: "center",
    },
  },
}));

export const PeoplePageSkeleton = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" style={{ maxWidth: "1071px" }}>
      <Box display={"flex"} justifyContent={"center"}>
        <Skeleton variant="text" width={337} height={38} />
      </Box>

      <Box
        pb={1}
        display={"flex"}
        className={`spacing ${classes.a}`}
        sx={(t) => ({
          paddingLeft: "32px",
          paddingTop: t.spacing(1),
          paddingBottom: t.spacing(1.2),
          display: "flex",
          [t.breakpoints.down("md")]: { paddingLeft: 0, margin: "auto", flexDirection: "column", alignItems: "center" },
        })}
      >
        {/* Sort Menu */}
        <Skeleton variant="rectangular" width={93} height={30} style={{ borderRadius: 5 }} />
        {/* Filter Menu */}
        <Skeleton variant="circular" width={30} height={30} />
        {/* Search Icon */}
        <Skeleton variant="circular" width={30} height={30} />
      </Box>

      <Grid container justifyContent={"center"} spacing={4} style={{ paddingBottom: 16 }}>
        {Array.from({ length: 20 }).map((_, i) => (
          <Grid key={`PERSON_SKE_${i}`} item style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Skeleton variant="rectangular" style={{ borderRadius: 5 }} width={166} height={250} />
            <Skeleton variant="text" width={150} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default PeoplePageSkeleton;
